import Component from "../../../lib/component";

export const ContentsConfig = {
    componentTypeKey: 'Contents',
    baseHtmlClass: 'nav_menu__contents',
    selector: '.nav_menu__contents',
};

export class Contents extends Component {

    static createContents(navMenu) {
        const element = document.createElement('div');
        element.classList.add(Contents.config.baseHtmlClass);
        navMenu.element.append(element);
        return new Contents(element, navMenu);
    }

    static get config() {
        return ContentsConfig;
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: Contents.config
        });

        this.navMenu = navMenu;

    }

    render() {
        // inputs within the contents should be readonly and disabled when the NavMenu is closed.
        this.element.querySelectorAll('input').forEach((inputElement) => {
            if (this.isOpen()) {
                inputElement.removeAttribute('readonly')
                inputElement.removeAttribute('disabled')
            } else {
                inputElement.setAttribute('readonly', !this.isOpen())
                inputElement.setAttribute('disabled', !this.isOpen())
            }
        });

        this.removeFromDisplay();
    }

    isOpen() {
        return this.navMenu.isOpen();
    }

    setContent(content) {
        this.element.innerHTML = content;
        this.navMenu.render();
    }

    // After the nav menu is closed, we hide the contents so they no longer take up render engine memory.

    removeFromDisplay() {
        if (this.isOpen()) {
            this.element.style.display = null;
        } else {
            window.setTimeout(() => {
                this.element.style.display = this.isOpen() ? null : 'none';
            }, 2000);
        }
    };


}